import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Loader from "../../components/NewView/Common/Loader";



const RegistrationComponent = React.lazy(() =>
    import("../../components/NewView/RootComponents/RegistrationComponent")
  );
const RegistrationPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Loader />}>
        <Helmet>
          <title>
            YellowHub
          </title>
          <meta
            name="description"
            content="Next LMS - Professional LMS Online Education Course React
            Template"
          />
        </Helmet>
        <RegistrationComponent />
      </Suspense>
    </Fragment>
  );
};

export default RegistrationPage;
